import { useMemo } from 'react';
import { ClickableIcon, IconVerticalMenu, Menu } from '@direct-frontend/components';
import { constructorTestIds } from '#shared/lib/testids';
import { useConstructorDeletePage } from '../../hooks/useConstructorDeletePage';
import { CONSTRUCTOR_ALLOWED_TO_HIDE_PAGES } from '../../model/constants';
import { changeConstructorPageStatus, useConstructorPageSettings, useConstructorPreviewPage } from '../../model/slices';
import styles from './ConstructorPageMenu.module.css';

export const ConstructorPageMenu = () => {
    const currentPageId = useConstructorPreviewPage();
    const page = useConstructorPageSettings(currentPageId);

    const { deletePage, renderConfirmModal } = useConstructorDeletePage();

    const items = useMemo(() => {
        const items = [];

        if (!page) {
            return [];
        }

        if (!page.alias || page.variant_type === 'alternative') {
            items.push({
                value: 'delete',
                content: <span data-testid={constructorTestIds.pageMenuDelete}>Удалить</span>,
                onAction: () => {
                    deletePage(currentPageId);
                },
            });
        }

        if (!page.alias || CONSTRUCTOR_ALLOWED_TO_HIDE_PAGES.includes(page.alias)) {
            items.push({
                value: 'hideOrShow',
                content: (
                    <span data-testid={constructorTestIds.pageMenuHideOrShow}>
                        {page.status === 'published' ? 'Скрыть страницу' : 'Показать страницу'}
                    </span>
                ),
                onAction: () => changeConstructorPageStatus(page.id, page.status === 'hidden' ? 'published' : 'hidden'),
            });
        }

        return items;
    }, [page, deletePage, currentPageId]);

    if (items.length === 0) {
        return null;
    }

    return (
        <>
            <Menu
                size="m"
                placement={['bottom-end', 'top-end']}
                aria-label="Контекстное меню"
                items={items}
                trigger={
                    <ClickableIcon
                        className={styles.root}
                        data-testid={constructorTestIds.pageMenuOpen}
                        role="supplementary"
                    >
                        <IconVerticalMenu size="20" />
                    </ClickableIcon>
                }
            />
            {items.some((item) => item.value === 'delete') && renderConfirmModal()}
        </>
    );
};
